import { makeStyles } from '@material-ui/core/styles';

const colorBlue = '#2E3092';

const useStyles = makeStyles((theme) => ({
    loginContainer: {
        background: '#F5F4F5',
        [theme.breakpoints.up('sm')]: {
            margin: '0 auto',
            width: '100%',
            height: '100%',
            position: 'relative',
        },
    },
    textTitle: {
        fontSize: 30,
        color: colorBlue,
        letterSpacing: 1.5,
        textTransform: 'uppercase',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        marginBottom: 10,
    },
    textSubTitle: {
        fontSize: 13,
        color: '#000000',
        textAlign: 'left',
        letterSpacing: 0,
        fontFamily: '"Open Sans", sans-serif',
        marginBottom: 10,
    },
    textFooter: {
        fontSize: 12,
        color: '#000000',
        textAlign: 'center',
        letterSpacing: 0,
        fontFamily: '"Open Sans", sans-serif',
    },
    textInput: {
        width: '100%',
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        borderRadius: 6,
        '& .MuiInputBase-root': {
            fontSize: 14,
        },
        '& .MuiInputBase-input': {
            color: '#000',
            height: 12,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#F5F4F5',
        },
    },
    formField: {
        marginTop: 20,
        padding: 0,
        paddingBottom: 20,
        position: 'relative',
        color: '#E0E0E0',
    },
    headerLogin: {
        [theme.breakpoints.down('xs')]: {
            width: 296,
            margin: '20px auto 0',
        },
    },
    containLeft: {
        height: '100vh',
        [theme.breakpoints.up('sm')]: {
            width: '48%',
            height: '98%',
            float: 'left',
            marginTop: 26,
            marginLeft: 21,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containRight: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
        [theme.breakpoints.up('sm')]: {
            width: '49%',
            float: 'right',
            height: '100%',
        },
    },
    rightImg: {
        width: '100%',
        objectFit: 'cover',
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        },
    },
    loginContent: {
        margin: '0 auto',
        maxWidth: 307,
    },
    companyLogo: {
        textAlign: 'center',
        marginBottom: 100,
    },
    btnLogin: {
        background: colorBlue,
        borderRadius: 5,
        padding: 6,
        width: '100%',
        '&:hover': {
            background: colorBlue,
        },
    },
    btnLoginText: {
        color: '#FFFFFF',
        padding: '5px 20px',
        letterSpacing: 0.9,
        fontSize: 18,
        textTransform: 'capitalize',
    },
    btnTextForgot: {
        display: 'block',
        margin: '-20px 0 20px 0',
        textAlign: 'right',
        fontSize: 14,
        color: '#000000',
        fontFamily: '"Open Sans", sans-serif',
    },
    btnVendor: {
        marginTop: 20,
        background: 'transparent',
        borderRadius: 7,
        border: `1px solid ${colorBlue}`,
        padding: 6,
        width: '100%',
        '&:hover': {
            background: 'transparent',
        },
    },
    btnVendorText: {
        color: colorBlue,
        letterSpacing: 1,
        fontSize: 20,
        textTransform: 'capitalize',
    },
    infoWrapper: {
        marginBottom: '12px',
        '& .alertContainer': {
            alignItems: 'center',
        },
        '& .infoTitle': {
            fontSize: 10,
            fontWeight: 'bold',
        },
        '& ul': {
            marginBlockStart: 0,
            marginBlockEnd: 0,
            paddingInlineStart: '16px',
        },
        '& .infoDesc': {
            fontSize: 10,
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '12px',
            marginRight: '12px',
        },
    },
}));

export default useStyles;
